import { configureStore } from '@reduxjs/toolkit';
import RootReducer from '../redux/RootReducer'

export const store = configureStore({
    reducer: RootReducer
});